import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { MIN_RETAILER_COUNT } from '../../../domain/retailers';

type RetailersSelectionProps = {
  onToggleItem: (name: string) => void;
  items: {
    name: string;
    color: string;
    visible: boolean;
  }[];
};

export const RetailersSelection = (props: RetailersSelectionProps) => {
  return (
    <Stack direction="column" gap="0.5rem" minWidth={200}>
      <Typography
        color={unifiedPlatformColorPalette.lightTextSecondary}
        variant="h6"
        fontWeight="bold"
      >
        Top {MIN_RETAILER_COUNT} Retailers
      </Typography>
      {props.items.map(item => (
        <FormControlLabel
          key={item.name}
          control={
            <Checkbox
              checked={item.visible}
              onChange={() => props.onToggleItem(item.name)}
              sx={{
                color: item.color,
                '&.Mui-checked': {
                  color: item.color,
                },
              }}
            />
          }
          label={item.name}
        />
      ))}
    </Stack>
  );
};
